import { NgModule } from '@angular/core';
import { GravimetricWidgetComponent } from '../components/template-widgets/sample-widgets/gravimetric-widget/gravimetric-widget.component';
import { MultiSampleTableWidgetComponent } from '../components/template-widgets/sample-widgets/multi-sample-table-widget/multi-sample-table-widget.component';
import { PpeListWidgetComponent } from '../components/template-widgets/sample-widgets/ppe-list-widget/ppe-list-widget.component';

@NgModule({
    imports: [
        GravimetricWidgetComponent,
        PpeListWidgetComponent,
        MultiSampleTableWidgetComponent,
    ],
    exports: [
        GravimetricWidgetComponent,
        PpeListWidgetComponent,
        MultiSampleTableWidgetComponent,
    ]
})
export class ReportWidgetsModule { }
